import React from 'react';
import GroupSettingsModal from '../chat/GroupSettingsModal';
import AddContactModal from '../modals/AddContactModal';
import QuantumShieldModal from '../modals/QuantumShieldModal';
import CreateGroupModal from '../modals/CreateGroupModal';
import JoinGroupModal from '../modals/JoinGroupModal';
import CreateChannelModal from '../modals/CreateChannelModal';
import KeyChangeWarningModal from '../modals/KeyChangeWarningModal';
import ContactProfileModal from '../modals/ContactProfileModal';

export default function AppModalLayer({
  contactProfile,
  setContactProfile,
  showAddContact,
  setShowAddContact,
  discoverGaiaId,
  setDiscoverGaiaId,
  handleDiscoverSubmit,
  discoverError,
  discoveredContact,
  addDiscoveredContact,
  displayGaiaID,
  t,
  showQuantumShieldModal,
  setShowQuantumShieldModal,
  showCreateGroupModal,
  setShowCreateGroupModal,
  groupNameInput,
  setGroupNameInput,
  groupDescriptionInput,
  setGroupDescriptionInput,
  groupAvatarInput,
  setGroupAvatarInput,
  handleCreateRoom,
  isCrisisRoomInput,
  setIsCrisisRoomInput,
  showJoinGroupModal,
  setShowJoinGroupModal,
  joinGroupHashInput,
  setJoinGroupHashInput,
  handleJoinRoom,
  showCreateChannelModal,
  setShowCreateChannelModal,
  newChannelNameInput,
  setNewChannelNameInput,
  handleCreateChannel,
  showGroupSettingsModal,
  setShowGroupSettingsModal,
  editGroupName,
  setEditGroupName,
  editGroupDescription,
  setEditGroupDescription,
  editGroupAvatar,
  setEditGroupAvatar,
  editGroupIsCrisis,
  setEditGroupIsCrisis,
  handleUpdateGroupSettings,
  handleDeleteGroup,
  keyChangeWarning,
  keyChangeConfirmInput,
  setKeyChangeConfirmInput,
  activeChatContact,
  currentMenu,
  onToggleContactBlock,
  onReportContact,
  onClearActiveChat,
  onCloseActiveChat
}) {
  const showActiveChatActions = !!(
    contactProfile &&
    activeChatContact &&
    currentMenu === 'chat' &&
    String(contactProfile.gaiaID || '').toLowerCase() === String(activeChatContact.gaiaID || '').toLowerCase()
  );

  return (
    <>
      {/* MODAL: CONTACT PROFILE (TRUST PASSPORT) */}
      <ContactProfileModal
        show={!!contactProfile}
        onClose={() => setContactProfile(null)}
        contactProfile={contactProfile}
        displayGaiaID={displayGaiaID}
        t={t}
        showChatActions={showActiveChatActions}
        onToggleBlock={showActiveChatActions ? () => onToggleContactBlock(contactProfile.gaiaID) : null}
        onReport={showActiveChatActions ? () => onReportContact(contactProfile.gaiaID) : null}
        onClearChat={showActiveChatActions ? onClearActiveChat : null}
        onCloseChat={showActiveChatActions ? onCloseActiveChat : null}
      />

      {/* MODAL: ADD CONTACT */}
      <AddContactModal
        show={showAddContact}
        onClose={() => setShowAddContact(false)}
        discoverGaiaId={discoverGaiaId}
        setDiscoverGaiaId={setDiscoverGaiaId}
        handleDiscoverSubmit={handleDiscoverSubmit}
        discoverError={discoverError}
        discoveredContact={discoveredContact}
        addDiscoveredContact={addDiscoveredContact}
        displayGaiaID={displayGaiaID}
        t={t}
      />

      {/* MODAL: QUANTUM SHIELD EXPLANATION */}
      <QuantumShieldModal
        show={showQuantumShieldModal}
        onClose={() => setShowQuantumShieldModal(false)}
        t={t}
      />

      {/* MODAL: CREATE GROUP */}
      <CreateGroupModal
        show={showCreateGroupModal}
        onClose={() => setShowCreateGroupModal(false)}
        groupNameInput={groupNameInput}
        setGroupNameInput={setGroupNameInput}
        groupDescriptionInput={groupDescriptionInput}
        setGroupDescriptionInput={setGroupDescriptionInput}
        groupAvatarInput={groupAvatarInput}
        setGroupAvatarInput={setGroupAvatarInput}
        handleCreateRoom={handleCreateRoom}
        isCrisisRoomInput={isCrisisRoomInput}
        setIsCrisisRoomInput={setIsCrisisRoomInput}
        t={t}
      />

      {/* MODAL: JOIN GROUP */}
      <JoinGroupModal
        show={showJoinGroupModal}
        onClose={() => setShowJoinGroupModal(false)}
        joinGroupHashInput={joinGroupHashInput}
        setJoinGroupHashInput={setJoinGroupHashInput}
        handleJoinRoom={handleJoinRoom}
        t={t}
      />

      {/* MODAL: CREATE CHANNEL */}
      <CreateChannelModal
        show={showCreateChannelModal}
        onClose={() => setShowCreateChannelModal(false)}
        newChannelNameInput={newChannelNameInput}
        setNewChannelNameInput={setNewChannelNameInput}
        handleCreateChannel={handleCreateChannel}
        t={t}
      />

      {/* MODAL: GROUP SETTINGS */}
      {showGroupSettingsModal && (
        <GroupSettingsModal
          name={editGroupName}
          description={editGroupDescription}
          avatar={editGroupAvatar}
          isCrisis={editGroupIsCrisis}
          onIsCrisisChange={setEditGroupIsCrisis}
          onNameChange={setEditGroupName}
          onDescriptionChange={setEditGroupDescription}
          onAvatarChange={setEditGroupAvatar}
          onSubmit={handleUpdateGroupSettings}
          onClose={() => setShowGroupSettingsModal(false)}
          onDelete={handleDeleteGroup}
        />
      )}

      {/* KEY CHANGE WARNING MODAL */}
      <KeyChangeWarningModal
        warning={keyChangeWarning}
        confirmInput={keyChangeConfirmInput}
        setConfirmInput={setKeyChangeConfirmInput}
        displayGaiaID={displayGaiaID}
        t={t}
      />
    </>
  );
}
